// extracted by css-extract-rspack-plugin
export default {"footer":"ModelPicker-module__footer__J6VWbBB"};